import { WifiOff } from 'lucide-react';
import { useContext } from 'react';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';
import { I18nProvider, useI18n } from '@/i18n';

const OfflineBanner = () => {
  const online = useOnlineStatus();
  if (online) return null;
  return <OfflineBannerInner />;
};

const OfflineBannerInner = () => {
  let label = 'You are offline';
  try {
    const { t } = useI18n();
    label = t('offline.banner');
  } catch {
    // I18nProvider not mounted yet — fall back silently
  }
  return (
    <div className="bg-accent/20 border-b border-accent/30 px-4 py-2 flex items-center gap-2 justify-center text-sm font-semibold text-accent">
      <WifiOff className="w-4 h-4 flex-shrink-0" />
      <span className="truncate">{label}</span>
    </div>
  );
};

export default OfflineBanner;
